import * as React from "react"

const SvgFilterAdd = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0205 2C17.4536 2.00009 17.7576 2.18335 17.9326 2.5498C18.1076 2.91636 18.0701 3.26637 17.8203 3.59961L12.0205 11V17C12.0205 17.2833 11.9241 17.5212 11.7324 17.7129C11.5409 17.9043 11.3035 17.9999 11.0205 18H9.02051C8.73725 18 8.49926 17.9045 8.30762 17.7129C8.11595 17.5212 8.02051 17.2833 8.02051 17V11L2.21973 3.59961C1.97005 3.26642 1.93251 2.9163 2.10743 2.5498C2.28243 2.18317 2.5872 2 3.02051 2H17.0205ZM10.0205 10.2998L14.9697 4H5.07032L10.0205 10.2998Z"
    />
    <path d="M15 19H17V21C17 21.2833 17.0958 21.5208 17.2875 21.7125C17.4792 21.9042 17.7167 22 18 22C18.2833 22 18.5208 21.9042 18.7125 21.7125C18.9042 21.5208 19 21.2833 19 21V19H21C21.2833 19 21.5208 18.9042 21.7125 18.7125C21.9042 18.5208 22 18.2833 22 18C22 17.7167 21.9042 17.4792 21.7125 17.2875C21.5208 17.0958 21.2833 17 21 17H19V15C19 14.7167 18.9042 14.4792 18.7125 14.2875C18.5208 14.0958 18.2833 14 18 14C17.7167 14 17.4792 14.0958 17.2875 14.2875C17.0958 14.4792 17 14.7167 17 15V17H15C14.7167 17 14.4792 17.0958 14.2875 17.2875C14.0958 17.4792 14 17.7167 14 18C14 18.2833 14.0958 18.5208 14.2875 18.7125C14.4792 18.9042 14.7167 19 15 19Z" />
  </svg>
)
export default SvgFilterAdd
